<script setup>
defineProps({
  header: {
    type: Object,
    required: true,
  },
});

const sortIconMap = {
  default: 'i-ph-caret-up-down',
  asc: 'i-ph-caret-up',
  desc: 'i-ph-caret-down',
};
</script>

<template>
  <span :class="sortIconMap[header.column.getIsSorted() || 'default']" />
</template>
